import Store_Sequences from "@bd-components/store-sequences";
import Store_Variable from "@bd-components/store-variable";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import { convertHexToRgba } from "@bd-utils/convertHexToRgba";
import $ from "jquery";

export default class BD_Question {
  // questionData = [];

  constructor(questionData) {
    // TODO make sure score is not included in questionData
    this.questionData = questionData;
  }

  showSubmitBtn(objMedia) {
    const template = objMedia.question.questionData.template;

    if (objMedia.question.questionData.type === "slider") {
      $(".questionCard").addClass("is-slider");
      $(".questionCard").find(".questionCard__actions").addClass("is-active");
    }

    if (
      objMedia.question.questionData.type === "open_field" ||
      template === "open_field"
    ) {
      $(".questionCard").addClass("is-open-field");
    }

    // To avoid confusion, Version3 refers to the component version, and STTVersion3 refers to the application version
    const isVersion3 = $(".gameScreen").hasClass("v3-questionCard");
    // const isSTTVersion3 = $(document.body).hasClass("stt-v3");
    const isSTTVersion3AndAbove = Number(CONFIG.STTVersion ?? 2) >= 3;
    const isNuclearQuickscan = CONFIG.siteSetup === "nuclear-quickscan";

    if (
      template === "multiple_choice_v2" ||
      template === "word_cloud_v2" ||
      template === "slider_v2"
    ) {
      $(".gameScreen").addClass(["is-slider", "v2-questionCard"]);
      $(".gameScreen").find(".questionCard__actions");
      $(".videoPlayer__button ").hide();

      if ($(".is-video").length) {
        $(".play-button").css("display", "flex");
      }

      if (isSTTVersion3AndAbove || isNuclearQuickscan) {
        $(document.body).addClass("stt-next");

        /**
         * Config variables that change appearance of question modal
         * - modalTransparency = percentage value from 0 - 100
         * - modalColor        = hex color code
         * - modalPosition     = 'Top [Left,Center,Right], Bottom [Left,Center,Right], True Center'
         */
        const modalTransparency = "100%"; // default should be 100%
        const modalColor = "#fff"; // default should be #fff
        const modalPosition = "Bottom Center"; // default should be Bottom Center

        const newColor = convertHexToRgba(modalColor, modalTransparency);

        $(".question-modal").css("background-color", newColor);
        $(".question-modal").addClass(
          modalPosition.toLowerCase().split(" ").join("-"),
        );
      }
    }

    if (isVersion3) {
      $(".gameScreen").removeClass(["is-slider", "v2-questionCard"]);
    }

    if (isNuclearQuickscan) {
      if (
        template === "multiple_choice_nuclear_quickscan" ||
        template === "word_cloud_nuclear_quickscan" ||
        template === "multiple_questions_nuclear_quickscan"
      ) {
        $(".gameScreen").addClass(["v3-questionCard"]);
      }
    }

    const answers = objMedia.question.questionData.answers;
    // show submit button immediately if no answers
    if (
      template !== "multiple_questions_nuclear_quickscan" &&
      (!answers || answers.length === 0)
    ) {
      // @ts-ignore
      $(this.elms.questionCard)
        .find(".questionCard__actions")
        .addClass("is-active");
    }
  }

  getEvents() {
    return [];
  }

  // implement getAnswer() for each question type
  getAnswer() {}

  /*
   * $el = submit button
   * ctx = current block object
   */
  submitAnswer($el, ctx) {
    // @ts-ignore
    const selectedAnswer = this.getAnswer(ctx);
    const template = this.questionData.template;
    // if (selectedAnswer === null || selectedAnswer === undefined) return false;

    const sttVer = Number(CONFIG.STTVersion ?? 2);
    const questionType = this.questionData.type;

    $el.attr("disabled", true);
    $el.addClass("is-loading");

    if (
      (template === "multiple_choice_v2" ||
        template === "word_cloud_v2" ||
        template === "slider_v2") &&
      questionType !== "multiple_choice" &&
      sttVer !== 4
    ) {
      $(".question-modal").removeClass("is-load-question");
      $(".question-modal").fadeOut(250);
    }

    const afterResponse = () => {
      $el.removeAttr("disabled");
      $el.removeClass("is-loading");
    };

    //add answer feedback correct or in-correct for stt v4
    if (sttVer === 4 && questionType === "multiple_choice") {
      $el.removeClass("is-loading");
      $(".js-answer").attr("disabled", "disabled");

      const $answerSelected = $(ctx.elms.answer.concat(":checked"));
      const answers = this.questionData.answers;
      const userAnswer = answers.find((answer) => answer.id === selectedAnswer);
      // let isCorrect = false;
      if (userAnswer && userAnswer.is_correct) {
        $answerSelected.closest("label").addClass("is-correct");
        // isCorrect = true;
      } else {
        const correctAnswer = answers.find((answer) => answer.is_correct);
        if (!correctAnswer) {
          console.error("no correct answer in the list");
          $el.addClass("is-loading");
          this.submitAnswerRequest(selectedAnswer, afterResponse);
          return;
        } else {
          $answerSelected.closest("label").addClass("is-incorrect");
          $(".js-answer")
            .filter(function () {
              return $(this).val() == correctAnswer.id;
            })
            .closest("label")
            .addClass("is-correct is-unselect");
        }
      }

      const self = this;
      setTimeout(function () {
        $el.addClass("is-loading");
        self.submitAnswerRequest(selectedAnswer, afterResponse);
      }, 4000);

      return;
    }

    this.submitAnswerRequest(selectedAnswer, afterResponse);
  }

  submitAnswerRequest(selectedAnswer, afterResponse = () => {}) {
    if (
      CONFIG.game_options.blindspot_show_after_building_block !== 0 &&
      CONFIG.game_options.blindspot_show_after_building_block ===
        BD_GAME_LOGIC.getCurrentBlockID()
    ) {
      //$('#questionaireOverlay').addClass('show')
      // console.log("close pre game called")
      window.parent.postMessage("bd-close", "*");
    } else if (
      CONFIG.game_options.blindspot_close_after_building_block_post_game !==
        0 &&
      CONFIG.game_options.blindspot_close_after_building_block_post_game ===
        BD_GAME_LOGIC.getCurrentBlockID()
    ) {
      //$('#questionaireOverlay').addClass('show')
      // console.log("close post game called")
      window.parent.postMessage("bd-close", "*");
    }

    const answer = {
      current_block: BD_GAME_LOGIC.getCurrentBlockID(),
      answer_data: selectedAnswer,
    };

    const storyMode = CONFIG.game_options.story_mode;
    const nextSeqId = Store_Sequences.getNext(answer);
    const isLikeResult = Store_Sequences.isLikeResult(nextSeqId);

    const submitToServer = (goToNext = true) => {
      bdapi
        .post("game/submit-answer", answer)
        .then((res) => {
          const resData = res.data;
          const data = resData.data;

          Store_Variable.set(data.answer_variables);

          if (!data) return afterResponse();

          if (goToNext) {
            BD_GAME_LOGIC.goTo(data.next_sequence);
            return false;
          }

          afterResponse();
        })
        .catch(() => {
          afterResponse();
        });
    };

    if (storyMode && !isLikeResult) {
      submitToServer(false);
      BD_GAME_LOGIC.goTo(nextSeqId);
    } else {
      submitToServer(true);
    }
  }
}
